'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

var _mobxReact = require('mobx-react');

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

var _fieldset = require('./styled/fieldset');

var _fieldset2 = _interopRequireDefault(_fieldset);

var _legend = require('./styled/legend');

var _legend2 = _interopRequireDefault(_legend);

var _fieldsetInner = require('./styled/fieldset-inner');

var _fieldsetInner2 = _interopRequireDefault(_fieldsetInner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fieldset = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Fieldset, _Component);

  function Fieldset() {
    (0, _classCallCheck3.default)(this, Fieldset);
    return (0, _possibleConstructorReturn3.default)(this, (Fieldset.__proto__ || (0, _getPrototypeOf2.default)(Fieldset)).apply(this, arguments));
  }

  (0, _createClass3.default)(Fieldset, [{
    key: 'getFormElements',
    value: function getFormElements() {
      var _this2 = this;

      var formElements = this.props.field.composite_elements || [];
      return formElements.map(function (field) {
        return _react2.default.createElement(_WebformElement2.default, {
          key: field['#webform_key'],
          field: field,
          formStore: _this2.props.formStore,
          parent: _this2.props.webformElement,
          onChange: _this2.props.onChange,
          onBlur: _this2.props.onBlur,
          settings: _this2.props.settings,
          webformSettings: _this2.props.webformSettings,
          webformPage: _this2.props.webformPage,
          form: _this2.props.form,
          status: _this2.props.status,
          url: _this2.props.url
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var formElements = this.getFormElements();
      return _react2.default.createElement(
        _fieldsetInner2.default,
        { style: this.props.style },
        !this.props.childrenAdjacent && this.props.children,
        formElements,
        this.props.childrenAdjacent && this.props.children
      );
    }
  }], [{
    key: 'getValue',


    /**
     * Get value from field based on key. Checks overridden values, and if so, provides master value
     *
     * @param field Full field object
     * @param key Key without leading #, e.g. pattern
     *
     * @return any Value of field or master, depending of overrides.
     */
    value: function getValue(field, key) {
      if (key.startsWith('#')) {
        throw new Error('Please use the field without leading hash.');
      }

      if (field['#override_' + key]) {
        return field['#' + key];
      }

      return (0, _getNested2.default)(function () {
        return field.composite_elements.find(function (element) {
          return element['#key'] === key;
        })['#default_value'];
      }, null);
    }
  }]);
  return Fieldset;
}(_react.Component), _class2.meta = {
  wrapper: _fieldset2.default,
  wrapperProps: { className: 'hrw-fieldset hrw-form-row' },
  label: _legend2.default,
  labelVisibility: 'invisible',
  hasValue: false
}, _class2.propTypes = {
  field: _propTypes2.default.shape({
    composite_elements: _propTypes2.default.array,
    '#webform_key': _propTypes2.default.string.isRequired
  }).isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired,
  webformElement: _propTypes2.default.instanceOf(_WebformElement2.default).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  settings: _propTypes2.default.shape().isRequired,
  children: _propTypes2.default.node,
  webformSettings: _propTypes2.default.shape().isRequired,
  style: _propTypes2.default.shape(),
  webformPage: _propTypes2.default.string,
  form: _propTypes2.default.shape({
    settings: _propTypes2.default.object.isRequired
  }).isRequired,
  status: _propTypes2.default.string.isRequired,
  childrenAdjacent: _propTypes2.default.bool,
  url: _propTypes2.default.string.isRequired
}, _class2.defaultProps = {
  children: [],
  style: {},
  webformPage: null,
  childrenAdjacent: false
}, _temp)) || _class;

exports.default = Fieldset;